import { AppStorage } from "@bbwt/utils/app-storage";
import { Note } from "@project/models/notes/note";

export class NoteOfflineStorage {
    private static readonly cacheKey = "api/note";

    static save(note: Note): Note {
        return this.correctDateTime(AppStorage.setOfflineEntity<Note>(this.cacheKey, note));
    }

    static get(id: string): Note {
        return this.correctDateTime(AppStorage.getOfflineEntity(id, this.cacheKey));
    }

    static update(note: Note): Note {
        return this.correctDateTime(AppStorage.replaceOfflineEntity<Note>(note, this.cacheKey));
    }

    static remove(id: string): Note {
        return this.correctDateTime(AppStorage.extractOfflineEntity<Note>(id, this.cacheKey));
    }

    static getAll(): Note[] {
        return AppStorage.getOfflineEntities<Note>(this.cacheKey).map(note => this.correctDateTime(note));
    }

    static getEpisodeNotes(episodeId: string): Note[] {
        return this.getAll().filter(note => note.episodeId === episodeId).map(note => this.correctDateTime(note));
    }

    static getPrescriptionNotes(prescriptionId: string): Note[] {
        return this.getAll().filter(note => note.prescriptionId === prescriptionId).map(note => this.correctDateTime(note));
    }

    private static correctDateTime(note: Note): Note {
        return note?.creationDate? { ...note, creationDate: new Date(note.creationDate) }: note;
    }
}
